import React, { Component } from "react";

import Video from "../../Components/Video";

class Inleiding extends Component {
  render() {
    return (
      <div className="inleiding">
        <Video video={"https://www.youtube.com/embed/d8neXTIs-ow"} />
      </div>
    );
  }
}

export default Inleiding;
